import React, { Component } from "react"
import { withRouter,Link } from "react-router-dom"
import Login from './Login';
import asyncComponent from "../AsyncComponent";
import { URLS } from "../urls.js"

import {Helmet} from "react-helmet";

// const AsyncSignup = asyncComponent(() => import("../login/Signup.js"))
// const AsyncResetPass = asyncComponent(() => import("../login/ResetPass.js"))

class LandingPage extends Component {
	constructor(props) {
		super(props)
		this.state = {
			modal: 1 //1 = signin, 2 = signup, 3 = resetpass, 0 = no modal
		}
	}

	componentWillMount() {
		// let isLoggedIn = localStorage.getItem("isLoggedIn")
		// if (isLoggedIn === "true") {
		// 	this.props.history.push(URLS.dashboard)
		// }
	}

	openSignup = () => {
		this.setState({ modal: 2 })
	}

	openSignin = () => {
		this.setState({ modal: 1 })
	}

	changeModal = m => {
		this.setState({ modal: m })
	}

	render() {
		return (
			<div className="account-page" style={{minHeight: '100vh'}}>
				<Helmet>
					<meta charSet="utf-8" />
					<meta name="robots" content="noindex, nofollow"></meta>
					<title>Fexspace HR</title>
				</Helmet>
                <div className="main-wrapper">
                    <div className="account-content">
					<Link to={`${URLS.jobList}`} className="btn btn-primary apply-btn">Apply Job</Link>
                        <div className="container">
                            <div className="account-logo">
								<Link to={`${URLS.login}`}> <img src="assets/img/blue-logo.png" alt="Fexspace HR" /></Link>
                            </div>
                            <Login />
                        </div>
                    </div>
                </div>
            </div>
		)
	}
}

export default withRouter(LandingPage)
